<!--
 * @Author: mrzou
 * @Date: 2021-03-18 10:22:52
 * @LastEditors: mrzou
 * @LastEditTime: 2021-07-13 10:59:31
 * @Description: file content
-->
<template>
  <div>
    <nuxt
      keep-alive
      :keep-alive-props="{
        include: [
          'd2MallIndex',
          'my-integration',
          'integralStatisticsIndex',
          'taskhall'
        ]
      }"
    />
  </div>
</template>
<script>
export default {
  created() {
    if (process.client) {
      this.$mat.init({
        sid: '500411881', //必填，统计用的appid
        cid: '500432840', //如果开启自定义事件，此项目为必填，否则不填
        autoReport: 0, //是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
        senseHash: 0, //hash锚点是否进入url统计
        senseQuery: 0, //url参数是否进入url统计
        performanceMonitor: 0, //是否开启性能监控
        ignoreParams: [] //开启url参数上报时，可忽略部分参数拼接上报
      })
      this.$mat.pgv()
    }
  },
  async mounted() {
    // await this.$bridge.login()
    window.localStorage.removeItem('isNewVersion')
    this.$bridge.getAppVersion()
    function flexible(window, document) {
      var docEl = document.documentElement
      var dpr = window.devicePixelRatio || 1

      // adjust body font size
      function setBodyFontSize() {
        if (document.body) {
          document.body.style.fontSize = 12 * dpr + 'px'
        } else {
          document.addEventListener('DOMContentLoaded', setBodyFontSize)
        }
      }
      setBodyFontSize()

      // set 1rem = viewWidth / 10
      function setRemUnit() {
        var rem = docEl.clientWidth / 10
        docEl.style.fontSize = rem + 'px'

        // Fixme: 由于系统字体缩放导致rem布局影响
        var realitySize = parseFloat(
          window.getComputedStyle(document.documentElement).fontSize
        )
        if (rem !== realitySize) {
          rem = (rem * rem) / realitySize
          docEl.style.fontSize = rem + 'px'
        }
      }

      setRemUnit()

      // reset rem unit on page resize
      window.addEventListener('resize', setRemUnit)
      window.addEventListener('pageshow', function(e) {
        if (e.persisted) {
          setRemUnit()
        }
      })

      // detect 0.5px supports
      if (dpr >= 2) {
        var fakeBody = document.createElement('body')
        var testElement = document.createElement('div')
        testElement.style.border = '.5px solid transparent'
        fakeBody.appendChild(testElement)
        docEl.appendChild(fakeBody)
        if (testElement.offsetHeight === 1) {
          docEl.classList.add('hairlines')
        }
        docEl.removeChild(fakeBody)
      }
    }
    flexible(window, document)
  },
  methods: {}
}
</script>
<style>
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
html,
body {
  -webkit-text-size-adjust: none !important;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC',
    'Helvetica Neue', STHeiti, 'Microsoft Yahei', Tahoma, Simsun, sans-serif,
    PingFang-SC-Bold;
}
.van-dialog__message {
  line-height: 22px !important;
}
</style>
